import { Component, ErrorInfo, ReactNode } from 'react';
import * as Sentry from '@sentry/browser';

import FullLoadingIndicator from '$app-web/components/full-loading-indicator';

interface Props {
    children?: ReactNode;
    name: string;
}

interface State {
    hasError: boolean;
}

class AppErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        const { name } = this.props;

        Sentry.withScope((scope) => {
            scope.setTag('catch_in', 'AppErrorBoundary');
            scope.setExtras({ errorInfo, name });
            Sentry.captureException(error);
        });
    }

    render() {
        const { hasError } = this.state;
        const { children } = this.props;

        if (hasError) {
            return <FullLoadingIndicator hasError />;
        } else {
            return children;
        }
    }
}

export default AppErrorBoundary;
